import * as React from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Text, View } from 'smoothie';

import { useGetMaintenanceStatus } from '../hooks/useGetMaintenanceStatus';

export default function MaintenanceBanner() {
    const { maintenanceInfo } = useGetMaintenanceStatus();
    const insets = useSafeAreaInsets();

    if (maintenanceInfo?.maintenanceMode && maintenanceInfo?.message !== null) {
        // NOTE: the current banner construction can cause a 'broken' experience on some pages
        // where content (e.g. a submit button) can be pushed out of view (e.g. behind the keyboard)
        // with no way to access it. We saw this on the OTP screen in the native app.
        //
        // To avoid this, we might want to have the banner overlay the screen content, but also have
        // an 'x' button to dismiss the banner so that content under it can be accessed. Perhaps also
        // have the banner be 80-90% of screen content width so you see that it is overlaying some content.
        // Not doing this now because we may not use this banner for such a long time that everything
        // could be very different when we need it again.
        return (
            <View
                backgroundColor="$peach400"
                borderBottomColor="$peach500"
                borderBottomWidth={1}
                paddingTop={insets.top + 5} // only pad inside the banner, not the rest of the app
                paddingBottom={10}
                paddingHorizontal={20}
                zIndex={1000}
            >
                <Text style={{ textAlign: 'center' }}>
                    {maintenanceInfo?.message}
                </Text>
            </View>
        );
    } else {
        return null;
    }
}
